export const SITE = {
  name: "خرابيش موشن",
  slogan: "خربش على السوق",
  whatsapp: "+201011064626",
  whatsappLink: "https://wa.me/201011064626",
  facebook: "https://www.facebook.com/Kharabeeshmotion",
  instagram: "https://www.instagram.com/kharabeeshstudio/",
};

export const NAV = [
  { to: "/", label: "الرئيسية", id: "home" },
  { to: "/about", label: "مين احنا", id: "about" },
  { to: "/portfolio", label: "شغلنا", id: "portfolio" },
  { to: "/contact", label: "كلمنا", id: "contact" },
];

export const waLink = (text) => `${SITE.whatsappLink}?text=${encodeURIComponent(text)}`;

export const loadSupport = () =>
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/public`)
    .then((r) => r.json())
    .then((d) => {
      if (d.support_whatsapp) {
        SITE.whatsapp = `+${d.support_whatsapp}`;
        SITE.whatsappLink = `https://wa.me/${d.support_whatsapp}`;
      }
    })
    .catch(() => {});
